import Vue from 'vue'
Vue.component( 'date-pick', require('vue-date-pick'))


// WEBPACK FOOTER //
// ./resources/js/plugins/date-pick.js